import {
  memo,
} from 'react';
import StoreBg from '../../assets/svg/store/store-bg.svg';
import StoreMainIco from '../../assets/svg/store/store-main-ico.svg';
import StoreDrawerContent from './QuestDrawerContent';

const Store = memo(() => (
  <div className="px-2 h-full flex flex-col pt-[.4rem] bg-questsPageBG absolute h-screen w-screen top-0 backdrop-blur-[40px]">
    <div className="mt-[86px] relative min-h-[100px] z-[-1]">
      <img
        className="absolute top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2"
        src={StoreBg}
        alt="treasures-bg"
      />
      <img
        className="absolute top-0 left-1/2 transform -translate-x-1/2"
        src={StoreMainIco}
        alt="treasures"
      />
      <span className="absolute bottom-[-34px] left-1/2 transform -translate-x-1/2 text-[22px] font-Bangers">
        Store
      </span>
    </div>
    <div className="w-full text-white mt-[2rem] mb-[6rem] h-full">
      <div className="px-2 py-3 h-full rounded-t-[0]">
        <StoreDrawerContent />
      </div>
    </div>
  </div>
));
Store.displayName = 'Store';
export default Store;
